import { styled } from '@innowise-group/mui-kit';

export const HightLighted = styled.span`
  ${({ theme }) => theme.fonts.primary[30]}
  color: ${({ theme }) => theme.palette.general.darkGrey[60]};
`;
